import classNames from "classnames"
import { FC } from "react"

import { useAppModeStore } from '@shared/config/appMode.store'

import styles from "./loader.module.css"
import { ILoaderProps } from "./loader.type"
import Icon from "../icon/Icon"

export const bnxLoaderIcon = "/tenants/com/img/loader.svg"
export const bouncingCirclesLoaderIcon = "/tenants/neuronext/img/loader.svg"

const Loader: FC<ILoaderProps> = ({
    icon,
    iconClassName,
    className,
    isFullPage = false,
    ...rest
}) => {
    const appMode = useAppModeStore((state) => state.mode)
    const loaderIcon = appMode === 'neuronext' ? bouncingCirclesLoaderIcon : bnxLoaderIcon

    const loaderIconType = icon ? icon : loaderIcon
    const loaderIconClassName = iconClassName ? iconClassName : styles.loadingIcon

    const loaderClassNames = classNames(
        styles.loader,
        { [styles.fullPage]: isFullPage },
        className,
    )
    return (
        <div className={ loaderClassNames } { ...rest }>
            <div className={ styles.loaderContent }>
                <Icon icon={ loaderIconType } className={ loaderIconClassName }/>
            </div>
        </div>
    )
}
export default Loader
